import { render, staticRenderFns } from "./PotentialWorkersTable.vue?vue&type=template&id=5cd8896c&scoped=true&"
import script from "./PotentialWorkersTable.vue?vue&type=script&lang=js&"
export * from "./PotentialWorkersTable.vue?vue&type=script&lang=js&"
import style0 from "./PotentialWorkersTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PotentialWorkersTable.vue?vue&type=style&index=1&id=5cd8896c&lang=scss&scoped=true&"
import style2 from "./PotentialWorkersTable.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd8896c",
  null
  
)

export default component.exports